import { OptionsMenuStorybook, TagERP } from "@finanedi.es/storybook"
import { faPen, faTrashCan } from "@fortawesome/pro-light-svg-icons"
import { ArticuloReadingDtoProps } from "api/DTOs/ArticuloReadingDto"
import { GetArticulosByFiltersQueryDtoProps } from "api/DTOs/GetArticulosByFiltersQueryDto"
import { TIPO_ARTICULO } from "api/Types/TipoArticulo"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"
import { CategoriasBodyTemplate, ImageArticuloBodyTemplate } from "../templates"
import { TIPO_ARTICULOS_OPTIONS_NUEVO } from "./constants"

export const ARTICULOS_COLUMNS = (
  t: TFunction,
  editArticulo: ({ id }: { id: string }) => Promise<void>,
  handleAskForDelete: (articulo: ArticuloReadingDtoProps) => void
) => [
  {
    key: "concepto",
    field: "concepto",
    header: `${t("articulos.tab.headerConcept")}`,
    sortable: true,
    sortField: "concepto",
    style: { width: "20%" },
  },
  {
    key: "precioVenta",
    field: "precioVenta",
    header: `${t("articulos.tab.headerSalesPrice")}`,
    sortField: "precioVenta",
    sortable: true,
    alignCol: "right",
    body: (rowData: GetArticulosByFiltersQueryDtoProps) => {
      return (
        <div className='tw-flex tw-justify-end'>
          {rowData?.precioVenta && frontendCurrency(rowData.precioVenta)}
        </div>
      )
    },
  },
  {
    key: "tipoArticulo",
    field: "tipoArticulo",
    header: `${t("articulos.tab.headerTypeArticle")}`,
    sortable: true,
    sortField: "tipoArticulo",
    className: "!tw-text-center",
    alignCol: "center",
    body: (rowData: GetArticulosByFiltersQueryDtoProps) => (
      <>
        {(rowData?.tipoArticulo ||
          rowData?.tipoArticulo === TIPO_ARTICULO.SERVICIO) && (
          <TagERP
            id={rowData.id}
            value={TIPO_ARTICULOS_OPTIONS_NUEVO(t)[rowData.tipoArticulo].label}
            color='neutral'
          />
        )}
      </>
    ),
  },
  {
    key: "categorias",
    field: "categorias",
    header: `${t("articulos.tab.headerCategory")}`,
    sortable: true,
    sortField: "categorias.count()",
    style: { width: "15%" },
    body: CategoriasBodyTemplate,
  },
  {
    key: "numeroReferencia",
    field: "numeroReferencia",
    header: `${t("articulos.tab.headerReference")}`,
    sortable: true,
    sortField: "numeroReferencia",
  },
  {
    key: "imagenBase64",
    field: "imagenBase64",
    body: (rowData: ArticuloReadingDtoProps) => {
      return (
        <div className='tw-flex tw-justify-center'>
          {ImageArticuloBodyTemplate(rowData)}
        </div>
      )
    },
    sortable: false,
  },
  {
    key: "actions",
    className: "!tw-px-2",
    style: { width: "3%" },
    body: (rowData: ArticuloReadingDtoProps) => (
      <div className='tw-flex tw-justify-end'>
        <OptionsMenuStorybook
          id={rowData.id}
          items={[
            {
              title: `${t("inventario.articulos.editItem")}`,
              hasRedirect: false,
              action: () => editArticulo(rowData),
              icon: faPen,
            },
            {
              title: `${t("inventario.articulos.deleteItem")}`,
              hasRedirect: false,
              action: () => handleAskForDelete(rowData),
              icon: faTrashCan,
              className: "tw-text-danger",
              iconClassName: "tw-text-danger",
            },
          ]}
          position='right'
        />
      </div>
    ),
  },
]
